import React, { ReactElement, useEffect, useState } from 'react';
import { Provider as StoreProvider } from 'react-redux';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import RegistrationView from 'views/RegistrationView';
import ResultsView from 'views/ResultsView';
import ScoringView from 'views/ScoringView';

import AuthModal from 'components/AuthModal/AuthModal';
import Header from 'components/Header/Header';
import Sidemenu from 'components/Sidemenu/Sidemenu';

import { useAppDispatch } from 'hooks';
import { store } from 'store';
import { reloadRole } from 'store/general';

function withStore(component: ReactElement) {
  return <StoreProvider store={store}>{component}</StoreProvider>;
}

function App() {
  const [sidemenuOpen, setSidemenuOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(reloadRole());
  }, []);

  const withComponents = (component: ReactElement) => (
    <>
      <Header toggleMenu={() => setSidemenuOpen(!sidemenuOpen)} />
      <AuthModal open={authModalOpen} onClose={() => setAuthModalOpen(false)} />
      <Sidemenu
        openAuthModal={() => setAuthModalOpen(true)}
        open={sidemenuOpen}
        onClose={() => setSidemenuOpen(false)}
      />
      {component}
    </>
  );

  const router = createBrowserRouter([
    {
      path: '/',
      element: withComponents(<ResultsView />),
    },
    {
      path: '/grading',
      element: withComponents(<ScoringView />),
    },
    {
      path: '/registration',
      element: withComponents(<RegistrationView />),
    },
    {
      path: '*',
      element: <Navigate to="/" />,
    },
  ]);

  return (
    <div className="app">
      <RouterProvider router={router} />
    </div>
  );
}

export default withStore(<App />);
